import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import subscriberService from '../../services/subscriber';

const initialState = {
  loading: false,
  subscriber: [],
  error: '',
  params: {
    page: 1,
    perPage: 15,
  },
  pagination: {},
};

export const fetchSubscriber = createAsyncThunk(
  'subscriber/fetchSubscriber',
  (params = {}) => {
    return subscriberService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const subscriberSlice = createSlice({
  name: 'subscriber',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchSubscriber.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSubscriber.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.subscriber = payload.data ?? [];
      state.pagination = payload.pagination ?? {};
      if (payload.pagination) {
        state.params.page = payload.pagination.page;
        state.params.perPage = payload.pagination.perPage;
      }
      state.error = '';
    });
    builder.addCase(fetchSubscriber.rejected, (state, action) => {
      state.loading = false;
      state.subscriber = [];
      state.error = action.error.message;
    });
  },
});

export default subscriberSlice.reducer;
